@for (banner of visibleBanners(); track banner.id) {
    <div class="c-page">
        <cc-notification-banner
            [text]="banner.text"
            [theme]="banner.theme"
            (closeEvent)="onClose(banner)" />
    </div>
}
